// 387
        $(document).ready(function () {
            var paddingTop = $('.main-nav__wrapper').outerHeight() + $('.custom-sticky-nav-wrapper').outerHeight();
            /**
            * Check a href for an anchor. If exists, and in document, scroll to it.
            * If href argument ommited, assumes context (this) is HTML Element,
            * which will be the case when invoked by jQuery after an event
            */
            function scrollToAnchor(href) {
                // If our Href points to a valid, non-empty anchor, and is on the same page (e.g. #foo)
                // Legacy jQuery and IE7 may have issues: http://stackoverflow.com/q/1593174
                if (href.indexOf('#') === 0 && href.length > 1) {
                    var $target = jQuery(href);
                    var scrollTarget = $target.offset().top - paddingTop;
                    // Older browser without pushState might flicker here, as they momentarily
                    // jump to the wrong position (IE < 10)
                    if ($target.length) {
                        var history;
                        jQuery('html, body').animate({ scrollTop: scrollTarget });
                        if (history && 'pushState' in history) {
                            history.pushState(
                                {},
                                document.title,
                                window.location.pathname + href
                            );
                            return false;
                        }
                    }
                }
            }
            function onClickAnchorLink(e) {
                var clicked = jQuery(e.currentTarget);
                scrollToAnchor(clicked.attr('href'));
            }

            // When our page loads, check to see if it contains and anchor
            if (window.location.hash) {
                scrollToAnchor(window.location.hash);
            }
            // Intercept all anchor clicks
            jQuery('body').on('click', '.sticky-nav a[href^="#"]', onClickAnchorLink);
        });


// 392
        $('.buynow').fancybox();
        $('.buynow').click(function() {
            var containerId = $(this).attr('data-destini-container');
            var associationId = $(this).attr('data-destini-association');
            destini.init(containerId);
            destini.loadWidget(associationId);
        });

            var acc = document.getElementsByClassName("accordion");
    var i;

    for (i = 0; i < acc.length; i++) {
        acc[i].addEventListener("click", function () {
            /* Toggle between adding and removing the "active" class,
            to highlight the button that controls the panel */
            this.classList.toggle("active");

            /* Toggle between hiding and showing the active panel */
            var panel = this.nextElementSibling;
            if (panel.style.display === "block") {
                panel.style.display = "none";
            } else {
                panel.style.display = "block";
            }
        });
    }

    var acc = document.getElementsByClassName("accordion");
    var i;

    for (i = 0; i < acc.length; i++) {
        acc[i].addEventListener("click", function () {
            /* Toggle between adding and removing the "active" class,
            to highlight the button that controls the panel */
            this.classList.toggle("active");

            /* Toggle between hiding and showing the active panel */
            var panel = this.nextElementSibling;
            if (panel.style.display === "block") {
                panel.style.display = "none";
            } else {
                panel.style.display = "block";
            }
        });
    }

